import { dateFromDateString, dateKeyToDateString, getDateString, getNormalizedDate, getWordNumber } from './dateUtils';
import { getWordOfTheDay, getRandomWord, secureAnswerScheduleMap, SecureTargetWord } from './wordUtils';
import { GameMode, GameStatus, loadCompletedDate, loadHintLetterDate } from './gameState';

export const shouldShowHintLetter = (mode: GameMode, hintLetter: string): boolean => {
  const today = getDateString();
  const hintLetterDate = loadHintLetterDate();

  return hintLetter && mode === GameMode.DAILY && today === hintLetterDate;
};

export const canContinueDailyGame = (mode: GameMode): boolean => {
  return mode === GameMode.DAILY && getDateString() !== loadCompletedDate(GameMode.DAILY)
};

export const canContinueEncoreGame = (mode: GameMode): boolean => {
  return mode === GameMode.ENCORE && getDateString() !== loadCompletedDate(GameMode.ENCORE)
};

export const getTargetWord = (mode: GameMode, providedDate?: Date): [SecureTargetWord, number | null] => {
  if ([GameMode.DAILY, GameMode.ARCHIVE].includes(mode)) {
    const date = getNormalizedDate(providedDate);
    const word = getWordOfTheDay(date);
    const wordNumber = getWordNumber(date);

    return [word, wordNumber];
  } else {
    return [getRandomWord(), null];
  }
};

export const getRandomArchiveDate = (gameCompletions: Record<string, GameStatus>): Date | null => {
  const eligibleDates = Object.entries(secureAnswerScheduleMap)
    .map(([dateKey, _]) => dateKeyToDateString(dateKey))
    .filter(date => dateFromDateString(date) < getNormalizedDate())
    .filter(date => !Object.keys(gameCompletions).includes(date));

  // If there are uncompleted dates, pick one randomly
  if (eligibleDates.length > 0) {
    const randomIndex = Math.floor(Math.random() * eligibleDates.length);
    return new Date(eligibleDates[randomIndex]);
  }

  return null;
};
